import script from "./RecommendedBrowserBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendedBrowserBanner.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendedBrowserBanner.vue?vue&type=style&index=0&id=6f7fbe7c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/r1/a/_Build/release/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7fbe7c"]])

export default __exports__